export const isValuePositive = (value: unknown): boolean => {
  if (typeof value === 'number') {
    return value > 0
  }
  if (typeof value === 'string') {
    return parseFloat(value.replace(',', '.')) > 0
  }
  return false
}
